import { render, staticRenderFns } from "./CmsResources.vue?vue&type=template&id=09fd7bf1&scoped=true&"
import script from "./CmsResources.vue?vue&type=script&lang=js&"
export * from "./CmsResources.vue?vue&type=script&lang=js&"
import style0 from "./CmsResources.vue?vue&type=style&index=0&id=09fd7bf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd7bf1",
  null
  
)

export default component.exports